import { Configure, InstantSearch } from 'react-instantsearch-hooks-web';
import { AlgoliaIndices } from '@sda/enums/algolia';
import { algoliaClient } from '@client/algolia';
import { getAlgoliaIndexName } from '@sda/utils/algolia';
import { useFormValues } from '@client/hooks/formik.hooks';
import { useSelector } from '@client/hooks/redux.hooks';
import { getMapLoaded } from '@client/selectors/features/map';
import { Hits } from './Hits';
import { useFormFilter } from './useFormFilter.hook';
import { showCallAttributesToRetrieve } from './constants';
import { useFilterLocation } from './useFilterLocation.hook';

const indexName = getAlgoliaIndexName(AlgoliaIndices.BEACONS_SCORE_DESC);

export const FetchShowCalls = () => {
  const filters = useFormFilter();
  const filterLocation = useFilterLocation();
  const query = useFormValues<string>('query');

  const isLoaded = useSelector(getMapLoaded);

  if (!isLoaded) {
    return null;
  }

  return (
    <InstantSearch
      searchClient={algoliaClient}
      indexName={indexName}
    >
      <Configure
        hitsPerPage={300}
        attributesToRetrieve={showCallAttributesToRetrieve}
        attributesToHighlight={[]}
        filters={filters}
        query={query}
        {...filterLocation}
      />

      <Hits />
    </InstantSearch>
  );
};
